import { Card, CardContent } from '@/common/ui/card'

import { QuickResponsesManager } from '../../../components/QuickResponses'

export function QuickResponsesSettingsPage() {
	return (
		<Card>
			<CardContent className="pt-4">
				<QuickResponsesManager />
			</CardContent>
		</Card>
	)
}
